import { h } from 'preact';
import { Text } from 'preact-i18n';

import { formatDateNo } from '../../lib/nsfCompetitionUi';

// The user's sent-alert ledger (GET /api/nsfcompetitionwatches/alerts).
function AlertHistory({ alerts = [] }) {
    if (!alerts || alerts.length === 0) {
        return (
            <div class='small text-body-secondary'>
                <Text id='terminliste.noAlerts'>No alerts sent yet.</Text>
            </div>
        );
    }
    return (
        <ul class='list-group list-group-flush small'>
            {alerts.map(alert => (
                <li key={alert.id} class='list-group-item px-0'>
                    <div class='d-flex justify-content-between'>
                        <a href={alert.url || '#'} class='fw-semibold'>
                            {alert.changeType === 'digest' && <i class='fa-duotone fa-calendar-week me-1' />}
                            {alert.title}
                        </a>
                        <span class='text-body-secondary text-nowrap ms-2'>{formatDateNo(alert.sentDate)}</span>
                    </div>
                    <div class='text-body-secondary'>{alert.message}</div>
                    <div class='text-body-tertiary'>
                        {alert.sentPush === 1 && <i class='fa-duotone fa-bell me-2' title='Push' />}
                        {alert.sentEmail === 1 && <i class='fa-duotone fa-envelope me-2' title='E-post' />}
                        {(alert.pushError || alert.emailError) && <i class='fa-duotone fa-triangle-exclamation text-warning' title={alert.pushError || alert.emailError} />}
                    </div>
                </li>
            ))}
        </ul>
    );
}

export default AlertHistory;
